module.exports = __webpack_public_path__ + "img/escalade.d83dc0f3.png";